<template>
  <div class="fb-welcome-inner" ref="inner" :class="classStyle">

    <div v-if="showWelcome()" :class="page">
      <h1 v-if="page=='profile'">Profile</h1>
      <h1
        v-else-if="page=='teacher-dashboard' && scrolled > 0 && scroll_direction == 'downscroll'"
        class="scrolled"
      >Dashboard</h1>
      <h1 v-else>Hi {{ username }}!</h1>
      <latest-activity></latest-activity>
    </div>
    <div v-if="page=='strategy' || page=='activity'">
      <div class="welcome-strategy md-layout">
        <div class="md-layout-item welcome-layout" v-if="$mq == 'large' || $mq == 'xlarge'">
          <div class="md-layout welcome-layout">
            <div class="welcome-image md-layout-item">
              <img alt :src="description.image"/>
            </div>
            <div class="md-layout-item welcome-text">
              <div class="rubrics-details">
                <span class="status">{{ activityStatus }}</span>
                <span class="score" v-if="isScored() && (
                activityStatusCode == $status.ACTIVITY_COMPLETED || activityStatusCode == $status.ACTIVITY_NEEDS_WORK)">
                  Score: {{ description.score }}%
                </span>
              </div>
              <div class="welcome-label md-layout-item">
                <div class="welcome-label-text"
                     :class="{ 'pr-8': group_settings.assignments == '1' }"
                     v-text="description.label"></div>
              </div>
              <div
                v-if="description.competencies && description.competencies.length"
                class="welcome-competencies"
              >Competency: {{description.competencies ? description.competencies.join(", ") : ""}}
              </div>
              <div class="welcome-description md-layout-item" v-html="description.description"></div>
              <div class="md-layout-item header-icons">
                <share-button
                  v-if="role == 'coach' && group_settings.assignments == '1'"
                  :nid="nid"
                ></share-button>
                <like-button
                  :nid="nid"
                  :show-counter="false"
                  :default-counter="0"
                  :default-liked="liked"
                ></like-button>
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout-item welcome-layout" v-else>
          <div class="md-layout welcome-layout">
            <div class="welcome-image md-layout-item">
              <img alt :src="description.image"/>
            </div>
            <div class="welcome-label welcome-layout md-layout-item">
              <div class="welcome-label-text"
                   :class="{ 'pr-8': group_settings.assignments == '1' }"
                   v-text="description.label">
              </div>
            </div>
            <div class="md-layout-item welcome-like">
              <div class="md-layout-item header-icons">
                <share-button
                  v-if="role == 'coach' && group_settings.assignments == '1'"
                  :nid="nid"
                ></share-button>
                <like-button
                  :nid="nid"
                  :show-counter="false"
                  :default-counter="0"
                  :default-liked="liked"
                ></like-button>
              </div>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item">
              <div
                v-if="description.competencies && description.competencies.length"
                class="welcome-competencies"
              >Competency: {{description.competencies ? description.competencies.join(", ") : ""}}
              </div>
              <div class="welcome-description" v-html="description.description"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="welcome-hide-btn">
        <md-button class="md-icon-button" @click="toggleSection">
          <md-icon :md-src="require('@/assets/welcome-down-arrow.svg')"/>
        </md-button>
      </div>
    </div>
    <div v-if="page=='member'" class="progress-welcome">
      <h1>Learner progress</h1>
      <div class="progress-description">
        <div class="user-info">
          <div class="row">
            <div class="label">Learner Name: </div>
            <span>{{ user_info.name }}</span>
          </div>
          <div class="row">
            <div class="label">Email: </div>
            <span>{{ user_info.email }}</span>
          </div>
          <!-- <div v-if="user_info.school" class="row"><div class="label">School: </div><span>{{ user_info.school }}</span></div> -->
          <div v-if="user_info.group" class="row">
            <div class="label">{{ user_info_labels.group }}:</div>
            <span>{{ user_info.group }}</span>
          </div>
          <div v-if="user_info.role" class="row">
            <div class="label">Role: </div>
            <span>{{ user_info.role }}</span>
          </div>
          <div v-if="completed.length !== 0" class="row">
            <div class="label">{{ user_info_labels.activities_completed_admin_progress }}: </div>
            <span>{{ completed.length }}</span>
          </div>
          <div v-if="user_info.badges_assigned && user_info.badges_assigned.length" class="row">
            <div class="label">{{ user_info_labels.badges_completed_admin_progress }}: </div>
            <span>{{ user_info.badges_completed }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="$route.name == 'assignment_submission_review'" class="progress-welcome">

      <h1>Learner submission</h1>
      <div class="breadcrumbs text-align-left">
        <span class="breadcrumb-item">
          <a href="/rubric-submissions">
            <md-icon class="back-arrow">keyboard_arrow_left</md-icon>All Submissions
          </a>
        </span>
      </div>
      <div class="assignment-desc progress-description">
        <div class="md-layout-item">
          <div class="md-layout">
            <div class="assignment-label md-layout-item">
              <div class>
                <div class="user-info">
                  <div class="row">
                    <div class="label">Learner Name:</div>
                    <span>{{ user_info.user_info.name }}</span>
                  </div>
                  <div v-if="user_info.user_info.group" class="row">
                    <div class="label">Group:</div>
                    <span>{{ user_info.user_info.group }}</span>
                  </div>
                  <!--<div v-if="user_info.user_info.school" class="row">
                    <div class="label">School:</div>
                    <span>{{ user_info.user_info.school }}</span>
                  </div> -->
                  <div v-if="user_info.user_info.role" class="row">
                    <div class="label">Role:</div>
                    <span>{{ user_info.user_info.role }}</span>
                  </div>
                  <div v-if="user_info.assignment.title" class="row">
                    <div class="label">Title:</div>
                    <span> {{ user_info.assignment.title }}</span>
                  </div>
                  <div class="row">
                    <div class="label">Status:</div>
                    <span>
                      <b v-if="user_info.completed">Completed</b>
                      <b v-else>{{user_info.status}}</b>
                    </span>
                  </div>

                  <div class="row">
                    <div class="label">Date Submitted:</div>
                    <span>{{ parseInt(user_info.changed) | moment('MM/DD/YYYY')}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="$mq == 'large' || $mq == 'xlarge'" class="assignment-status md-layout-item">
              <div class="status">
                Status:
                <b v-if="user_info.completed">Completed</b>
                <b v-else>{{user_info.status}}</b>
              </div>
            </div>
            <div v-if="$mq == 'large' || $mq == 'xlarge'" class="assignment-label md-layout-item"></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="page=='activity-submission'" class="progress-welcome">
      <h1>Learner submission</h1>
      <div class="breadcrumbs">
        <span class="breadcrumb-item">



          <a v-if="!isAdmin" href="/rubric-submissions">
            <md-icon class="back-arrow">keyboard_arrow_left</md-icon>All Submissions
          </a>
          <a v-else href="/submissions">
            <md-icon class="back-arrow">keyboard_arrow_left</md-icon>All Submissions
          </a>
        </span>
      </div>
      <div class="progress-description">
        <div class="user-info">
          <div class="row">
            <div class="label">Learner Name:</div>
            <span>{{ user_info.name }}</span>
          </div>
          <!-- <div v-if="user_info.school" class="row"><div class="label">School: </div><span>{{ user_info.school }}</span></div> -->
          <div v-if="user_info.group_type" class="row">
            <div class="label">{{ user_info.group_type }}:</div>
            <span>{{ user_info.group_title }}</span>
          </div>
          <div v-if="user_info.role" class="row">
            <div class="label">Role:</div>
            <span>{{ user_info.role }}</span>
          </div>
          <div class="row">
            <div class="label" v-if="user_info.formType === 'Activity'">Activity:</div>
            <div class="label" v-else>Strategy:</div>
            <span>
              <!-- <a :href=user_info.activityUrl target="_blank"> -->
              {{ user_info.activity }}
              <!-- </a> -->
            </span>
          </div>
          <div class="row" v-if="user_info.formType !== 'Activity'">
            <div class="label">Form:</div>
            <span>{{ user_info.formType }}</span>
          </div>
          <div class="row">
            <div class="label">Date Submitted:</div>
            <span>{{ user_info.submitted }}</span>
          </div>
          <div v-if="user_info.last_submissions" class="row">
            <div class="label">Last Submissions:</div>
            <span>
              <a
                v-bind:key="index"
                v-for="(submission, index) in user_info.last_submissions"
                :href="submission.link"
                class="submission-item"
              >{{ submission.type }}</a>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="page=='activity-submission-learner'" class="activity-submission-learner">
      <div class="welcome-strategy md-layout">
        <div class="md-layout-item welcome-layout" v-if="$mq == 'large' || $mq == 'xlarge'">
          <div class="md-layout welcome-layout">
            <div class="welcome-image md-layout-item">
              <img alt :src="user_info.image"/>
            </div>
            <div class="md-layout-item welcome-text">
              <div class="rubrics-details">
                <span class="status">{{ this.$status_text[user_info.status] }}</span>
              </div>
              <div class="welcome-label welcome-layout md-layout-item">
                <div class="welcome-label-text"
                     v-text="user_info.activity">
                </div>
              </div>
              <div class="md-layout-item submitted">Submitted {{ user_info.submitted }}</div>
              <div class="md-layout-item btn-activity">
                <md-button class="md-raised md-primary fb-next" :href="user_info.activityUrl">Review Activity</md-button>
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout-item welcome-layout" v-else>
          <div class="md-layout welcome-layout">
            <div class="welcome-label welcome-layout md-layout-item">
              <div class="welcome-label-text"
                   v-text="user_info.activity">
              </div>
              <div class="md-layout-item submitted">Submitted {{ user_info.submitted }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="page=='coach'">
      <h1 v-if="scrolled > 0 && scroll_direction == 'downscroll'" class="scrolled">Home</h1>
      <h1 v-else>Hi, {{ username }}! <span class="user-role" v-if="role == 'coach'">{{coach_label}}</span></h1>
      <recent-activity v-show="$mq == 'large' || $mq == 'xlarge'" @notification-toggle="notificationToggle"></recent-activity>
    </div>
    <div v-if="page=='learner' && subpage == '' ">
      <h1 v-if="scrolled > 0 && scroll_direction == 'downscroll'" class="scrolled">Home</h1>
      <h1 v-else>Hi, {{ username }}! <span class="user-role" v-if="role == 'coach'">{{coach_label}}</span></h1>
      <div class="learner-header-wrapper">
        <latest-activity></latest-activity>
        <recent-activity v-show="$mq == 'large' || $mq == 'xlarge'"
                         @notification-toggle="notificationToggle"></recent-activity>
      </div>
    </div>
    <div v-if="page=='learner' && subpage != '' ">
      <h1>Learner Progress: {{ user_info.name }}</h1>
      <div class="breadcrumbs">
        <span class="breadcrumb-item">
          <a href="/coach">
            <md-icon class="back-arrow">keyboard_arrow_left</md-icon>All Learners
          </a>
        </span>
      </div>
      <div class="progress-description">
        <div class="user-info">
          <div class="row">
            <div class="label">Learner Name: </div>
            <span>{{ user_info.name }}</span>
          </div>
          <div class="row">
            <div class="label">Email: </div>
            <span>{{ user_info.email }}</span>
          </div>
          <div v-if="user_info.group" class="row">
            <div class="label">Group: </div>
            <span>{{ user_info.group }}</span>
          </div>
          <div v-if="user_info.role" class="row">
            <div class="label">Role: </div>
            <span>{{ user_info.role }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="page=='teacher-dashboard'">
      <h1 class="main-title">Dashboard</h1>
    </div>
  </div>
</template>
<script>
  import RecentActivity from "./RecentActivity";
  import LatestActivity from "./LatestActivity";
  import ShareButton from "@/components/ShareButton";

  export default {
    name: "WelcomeMessage",
    props: ["routeName", "nid", "big", "scroll", "status"],
    components: {
      LatestActivity,
      RecentActivity,
      ShareButton
    },
    data() {
      let availableRoles = Object.values(window.drupalSettings.user.all_available_roles);
      let activityStatusCode = 0;
      return {
        username: "",
        isAdmin: availableRoles.includes('group_administrator') || availableRoles.includes('subgroup_administrator'),
        role: window.drupalSettings.user.role,
        group_settings: window.drupalSettings.user.group_settings || {},
        coach_label: window.drupalSettings.group_catch_config.labels.coach_label &&
          window.drupalSettings.group_catch_config.labels.coach_label != '' ?
          window.drupalSettings.group_catch_config.labels.coach_label :
          'Coach',
        init_height: 0,
        page: "",
        subpage: "",
        description: {},
        toggle: 1,
        scrolled: 0,
        user_toggle: 0,
        progress_description: {},
        completed: [],
        liked: false,
        scroll_direction: this.scroll,
        user_info: [],
        user_info_labels: [],
        activityStatusCode: activityStatusCode,
        activityStatus: this.$status_text[activityStatusCode],
        hide_on: [
          "assigned",
          "assignment-submission",
          "assignment",
          "assignments",
          "coach",
          "learner",
          "observation",
          "observations",
          "observation-submission",
          "activity-submission",
          "activity-submission-learner",
          "rubric-submissions",
          "submissions",
          "member",
          "dashboard",
          "teacher-dashboard",
          "strategy",
          "progress",
          "best-practices",
          "activity",
          "profile",
          "pre-requisite",
          "not-available",
          "experience-path-report"
        ],
      };
    },
    created() {
      this.page = window.location.pathname.split("/")[1];
      this.subpage = window.location.pathname.split("/")[2] ? window.location.pathname.split("/")[2] : '';
      this.liked = window.drupalSettings.liked_by_user;
    },
    computed: {
      classStyle() {
        let classes = {};
        if (
          (this.page == "strategy" ||
            this.page == "best-practices" ||
            this.page == "activity") &&
          this.toggle
        ) {
          classes = {
            small: true,
            big: false,
          };
        } else if (
          (this.page == "strategy" ||
            this.page == "best-practices" ||
            this.page == "activity") &&
          !this.toggle
        ) {
          classes = {
            small: false,
            big: true,
          };
        } else if (this.scroll && this.scroll == "downscroll") {
          classes = {
            small: true,
            big: false,
          };
        } else if (this.scroll == "upscroll" || !this.scroll) {
          classes = {
            small: false,
            big: true,
          };
        }
        classes.scrolled = this.scrolled;
        classes[this.routeName] = this.routeName;
        classes[this.role] = this.role;
        this.scroll_direction = this.scroll;
        return classes;
      },
    },
    methods: {
      log(msg) {
        console.log(msg);
      },
      isScored() {
        return ['self_scored', 'reviewer_scored', 'peer_scored'].indexOf(window.drupalSettings.evaluation_type) === -1 ? false : true;
      },
      showWelcome() {
        if (this.hide_on.indexOf(this.page) === -1) {
          return true;
        }
        return false;
      },
      toggleSection() {
        this.toggle = !this.toggle;
      },
      notificationToggle() {
        this.$emit("notification-toggle");
      },
    },
    mounted() {
      this.init_height = this.$refs.inner ? this.$refs.inner.offsetHeight : 0;

      this.group_settings = window.drupalSettings.user.group_settings || {};

        this.username = window.drupalSettings.user
        ? window.drupalSettings.user.username
        : "";

      if (window.drupalSettings.assignment_submission) {
        this.user_info = window.drupalSettings.assignment_submission;
      }

      if (window.drupalSettings.controller) {
        this.progress_description = window.drupalSettings.controller
          .progress_description
          ? window.drupalSettings.controller.progress_description
          : null;
        this.completed = window.drupalSettings.controller.all_activity
          ? window.drupalSettings.controller.all_activity
          : [];
        this.user_info = window.drupalSettings.controller.user_info
          ? window.drupalSettings.controller.user_info
          : [];
        this.user_info_labels = window.drupalSettings.controller.user_info_labels
          ? window.drupalSettings.controller.user_info_labels
          : [];
      }

      let self = this;
      if (this.page == "teacher-dashboard" || this.page == "progress") {
        this.toggle = 0;
      }
      document.querySelector(".md-app-scroller").style.paddingTop = null;
      setTimeout(() => {
        let height = document.querySelector(".fb-welcome")
          ? document.querySelector(".fb-welcome").offsetHeight
          : 0;

        // Ugly hack for the coach home page.
        if (this.page == "coach") {
          height = 20;
        }

        document.querySelector(".md-app-scroller").style.paddingTop =
          height + "px";
      }, 300);
      var scheduledAnimationFrame;

      function readAndUpdatePage() {
        scheduledAnimationFrame = false;
      }

      var throttled = _.throttle(() => {
        if (scheduledAnimationFrame) {
          return;
        }
        let scrolled = window.pageYOffset || document.documentElement.scrollTop;
        if (scrolled < 0) {
          return;
        }
        if (scrolled + window.innerHeight > document.body.scrollHeight) {
          return;
        }
        self.scrolled = scrolled;

        if (
          self.page == "progress" &&
          (self.$mq == "large" || self.$mq == "xlarge")
        ) {
          self.scrolled = 0;
        }
        if (self.page == "teacher-dashboard" || self.page == "progress") {
          self.toggle = !!self.scrolled;
        }
        scheduledAnimationFrame = true;
        requestAnimationFrame(readAndUpdatePage);
      }, 100);
      window.addEventListener("scroll", throttled);
    },
    watch: {

      status(newVal) {
        if (newVal) {
          this.activityStatusCode = newVal;
          this.activityStatus = this.$status_text[newVal];
        }
      },

      nid(newVal) {
        if (newVal && window.drupalSettings.form_builder[newVal]["tabs"] && window.drupalSettings.form_builder[newVal]["tabs"].hasOwnProperty('description')) {
          this.description =
            window.drupalSettings.form_builder[newVal]["tabs"].description;
            if (window.drupalSettings.form_builder[newVal]["tabs"].description.hasOwnProperty('status')) {
              this.activityStatusCode =  window.drupalSettings.form_builder[newVal]["tabs"].description.status;
              this.activityStatus = this.$status_text[this.activityStatusCode];
            }

        }
      },

      "$route.name": function (newRoute) {
        if (
          newRoute == "field_ready_form" &&
          (this.$mq == "large" || this.$mq == "xlarge")
        ) {
          this.toggle = 0;
        } else {
          this.toggle = 1;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .user-role {
    display: inline-block;
    border-radius: 10px;
    background-color: $blue-dark;
    font-size: 14px;
    font-weight: bold;
    padding: 4px 16px;
    height: 25px;
    line-height: normal;
    color: $white;
    position: relative;
    margin-left: 20px;
    margin-top: auto;
    margin-bottom: auto;
    @media all and (max-width: $breakpoint-medium) {
      color: $blue-dark;
      background-color: $white;
    }
  }
  .strategy,
  .module-activity {
    .welcome-layout {
      // @media all and (min-width: $breakpoint-medium) {
      min-width: 0;
      flex-wrap: nowrap;
      // }
    }
    .welcome-hide-btn {
      text-align: center;
    }
    .welcome-text {
      // @media all and (min-width: $breakpoint-medium) {
      align-self: center;
      min-width: 0;
      // }
    }
    .welcome-like {
      max-width: 40px;
      @media all and (max-width: $breakpoint-medium) {
        align-self: center;

        .share-button-wrapper {
          padding-left: 3px;
        }
      }
    }
    .welcome-description {
      padding-top: 16px;
      width: 100%;
      font-size: 14px;
      font-weight: normal;
      line-height: 21px;
      font-family: $font-filson-soft;
      color: #ffffff;
      opacity: 1;
    }
    .small {
      .welcome-strategy {
        & > .md-layout {
          width: 100%;
        }
        .welcome-label {
          .welcome-label-text {
            padding: 5px 30px 5px 5px;
            overflow: hidden;
            //padding: 5px;
            text-overflow: ellipsis;
            white-space: nowrap;
            align-self: center;
            &.pr-8 {
              padding-right: 60px;
            }
          }
        }
      }
      &.scrolled {
        @media all and (max-width: $breakpoint-medium) {
          max-height: 40px;
          min-height: 40px;

          .welcome-label-text {
            &.pr-8 {
              margin-top: 0!important;
            }
          }
        }
      }
      max-height: 80px;
      min-height: 80px;
      &.field_set_form,
      &.field_go_form,
      &.activity_form,
      &.activity_form_thanks,
      &.activity_form_error {
        @media all and (max-width: $breakpoint-medium) {
          //max-height: 40px;
          //min-height: 40px;

          .like {
            display: none;
          }
          .welcome-hide-btn {
            //left: auto;
            //right: 0;
            //margin-left: inherit;
            //bottom: 0;
          }

          .welcome-label-text {
            &.pr-8 {
              margin-top: 13px;
            }
          }
        }
        .welcome-image {
          display: none;
          @media all and (min-width: $breakpoint-medium) {
            display: block;
          }
        }


        .welcome-description,
        .welcome-competencies {
          opacity: 0;
          position: absolute;
        }
      }
      &.field_ready_form {
        &.scrolled {
          .welcome-image {
            display: none;
          }
        }
        .welcome-description,
        .welcome-competencies {
          opacity: 0;
          position: absolute;
        }
      }
      .welcome-strategy {
        margin-top: 0px;
      }
      .welcome-hide-btn {
        left: 50%;
        right: auto;
        margin-left: -20px;
        bottom: -9px;
        position: absolute;

        transform: rotateX(180deg);
      }
    }
    .big {
      @media all and (max-width: $breakpoint-medium) {
        max-height: 400px;
        transition: 0.5s !important;
      }
      &.field_ready_form {
        .welcome-description,
        .welcome-competencies {
          opacity: 1;
          position: relative;
        }
      }
      .welcome-strategy {
        .header-icons {
          @media all and (min-width: $breakpoint-medium) {
            position: absolute;
            top: 15px;
            right: 10px;
            display: flex;
          }
        }
        .welcome-image {
          align-self: flex-start;
          @media all and (min-width: $breakpoint-medium) {
            width: 140px;
            min-width: 140px;
            margin-right: 32px;
            img {
              height: 140px;
              width: 140px;
            }
          }
          @media all and (max-width: $breakpoint-medium) {
            img {
              height: 70px;
              width: 70px;
            }
          }
        }
        .welcome-label {
          font-size: 20px;
          font-family: $font-filson-soft;
          @media all and (min-width: $breakpoint-medium) {
            margin-top: 32px;
            padding-right: 38px;
            font-size: 20px;
            &.pr-8 {
              padding-right: 80px !important;
            }
          }
          @media all and (max-width: $breakpoint-medium) {
            font-size: 16px;
            align-self: center;
          }


        }
        .welcome-competencies {
          margin-top: 24px;
          font-size: 16px;
          font-weight: 600;
          font-family: $font-source-sans-pro;
          p {
            font-family: $font-source-sans-pro;
          }
          @media all and (max-width: $breakpoint-medium) {
            font-size: 14px;
          }
        }
        .welcome-description {
          @media all and (min-width: $breakpoint-medium) {
            padding-top: 8px;
          }
          @media all and (max-width: $breakpoint-medium) {
            font-size: 14px;
          }
          font-size: 16px;
          font-weight: 300;
          font-family: $font-source-sans-pro;
          & /deep/ p {
            font-family: $font-source-sans-pro;
          }
        }
      }
    }
  }

  .scrolled {
    .big {
      .like.like {
        display: block;
      }
    }
    .small {
        .header-icons {
          display: none;
        }
        .welcome-hide-btn {
          left: auto;
          right: 0px;
          margin-left: inherit;
          bottom: 0;
        }
    }
  }

  .small {
    .header-icons {
      display: flex;
      position: absolute;
      top: 15px;
      right: 10px;
    }
  }
  .welcome-strategy {
    & > .md-layout {
      align-items: center;
    }
    .welcome-image {
      align-self: flex-start;
      width: 80px;
      max-width: 80px;
      min-width: 80px;
      img {
        height: 70px;
        width: 70px;
      }
    }
    .welcome-label {
      font-family: $font-filson-soft;
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      @media all and (max-width: $breakpoint-medium) {
        align-self: center;
        padding: 5px;
      }
      @media all and (min-width: $breakpoint-medium) {
        font-size: 20px;
      }
    }
  }

  .small {
    max-height: 40px;

    .welcome-label {
      white-space: nowrap;
      height: 40px;
      overflow-wrap: nowrap;
      overflow: hidden;
      .welcome-label-text {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .latest-activity {
      display: block;
    }
    .latest-activity-inner {
      opacity: 0;
      transition: $transition;
      transition: var(--transition);
    }
  }

  .big {
    @media all and (max-width: $breakpoint-medium) {
      max-height: 400px;
      transition: 0.5s !important;
    }
  }

  .fb-welcome-inner {
    transition: $transition;
    transition: var(--transition);
    transform: translate3d(0, 0, 0);
    padding: 0px;
    h1 {
      margin: 0;
    }
  }

  .rubrics-details {
    color: rgb(255, 255, 255);
    font-family: $font-filson-soft;
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    padding: 5px;
    opacity: 0.55;
    .status {
      padding-right: 15px;
    }
  }

  .activity-submission-learner {
    .welcome-label {
      padding: 5px;
    }
    .submitted {
      margin-top: 5px;
      padding: 5px;
      @media all and (max-width: $breakpoint-medium) {
        padding-left: 0;
      }
    }
    .btn-activity {
      position: absolute;
      right: 0;
      top: 15px;

      .md-primary {
        color: $blue-dark!important;
        background-color: $white!important;
      }
    }
  }
</style>
